/**
 * @description Идентификатор действия запроса количества новых уведомлений.
 * @type {string}
 */
export const NOTIFICATION_REQUEST = 'NOTIFICATION_REQUEST';

export default NOTIFICATION_REQUEST;
